import { useEffect, useState } from "react";
import ApiService from "../core/service/ApiService";
import { Button, Card, Divider, List, Table, Tabs, Typography } from "antd";
import {
    CloudDownloadOutlined,
    FileImageOutlined,
    FilePdfOutlined, FolderOpenOutlined,
    LoadingOutlined,
    ShareAltOutlined
} from "@ant-design/icons";
import { t } from "i18next";
import { LocalStorageService } from "../core/service/LocalStorageService";
import PatientLocalStorage from "./PatientLocalStorage";
import { isMobile } from "react-device-detect";
import TokenDurationModal from "./TokenDurationModal";

export default function PatientResult() {
    const [reports, setReports] = useState([]);
    const [studies, setStudies] = useState([]);
    const patient = PatientLocalStorage.getInformation()

    const currentUrl = window.location.href;
    console.log(currentUrl);

    const getReports = async () => {
        const res = await ApiService.PatientApp.GetReports();
        if (res.success) {
            setReports(res.data);
        }
    };

    const getStudies = async () => {
        const res = await ApiService.PatientApp.GetStudies();
        if (res.success) {
            const _studies = [];

            for (const report of res.data) {
                let study = _studies.find(
                    x =>
                        x.studyDate === report.studyDate
                    // && x.studyDescription === report.studyDescription
                );

                if (!study) {
                    study = {
                        ...report,
                        studyDate: report.studyDate,
                        studyDescription: report.studyDescription,
                        modality: report.modality,
                        numberOfStudyRelatedInstance: report.numberOfStudyRelatedInstance,
                        reports: [report]
                    };
                    _studies.push(study);
                } else {
                    study.reports.push(report);
                }
            }

            setStudies(_studies);
        }
    };


    const openRisPdf = async (reportId) => {
        const res = await ApiService.PatientApp.GetReportPdf(reportId);
        if (res.success) {
            const data = `data:application/pdf;base64,${encodeURI(res.data)}`
            const byteCharacters = atob(res.data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            // window.open(blobUrl, '_blank');
            window.setTimeout(() => window.open(blobUrl, ''), 500);
            // window.open(blobUrl, '_');
        }
    }

    const openPdf = async (fileId) => {
        debugger;

        const res = await ApiService.PatientApp.DownloadFile(fileId)
        if (res.success) {
            if (res.success) {
                console.log('res.data=', res.data);
                window.open(res.data, "_blank");
            }
        }
    }

    const downloadZip = async (item) => {
        const date = new Date(item.studyDate);
        const txt = `${item.accessionNumber}_${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${(date.getDate()).toString().padStart(2, '0')}`;
        const res = await ApiService.PatientApp.GetDicomZip(item.studyId, txt);
    }

    const getOhifLink = async (item, tokenType) => {
        try {
            const res = await ApiService.PatientApp.GetStudyMetadata(item.studyId, tokenType);
            const shareUrl = `${window?.AppSettings?.server?.api}/api/ohif/viewer/dicomjson?url=${res}`;

            const data = await ApiService.PatientApp.CreateUrl(shareUrl);
            if (navigator.share) {
                try {
                    await navigator.share({
                        title: t('Study Viewer Link'),
                        text: `${patient?.name} ${patient?.lastname}\n${item.displayName}`,
                        url: `${window?.AppSettings?.server?.api}/api/PatientApp/GetUrl/${data.data}`
                    });
                } catch (e) {
                    navigator.clipboard.writeText(shareUrl).then(() => alert(t('Link copied to clipboard')));
                }
            } else {
                navigator.clipboard.writeText(shareUrl).then(() => alert(t('Link copied to clipboard')));
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                alert("Paylaşılan bağlantının süresi dolmuştur. Erişim sahibinden yeni bir bağlantı paylaşmasını talep ediniz ");
                window.location.href = "/error";
            } else {
                alert("Sunucuya ulaşılamıyor veya başka bir hata oluştu.");
                window.location.href = "/error";
            }
        }
    }

    const getLink = async (item, tokenType) => {
        const date = new Date(item.studyDate);
        const date_txt = `${date.getFullYear()}${(date.getMonth() + 1).toString().padStart(2, '0')}${(date.getDate()).toString().padStart(2, '0')}`
        const txt = `${item.accessionNumber}_${date_txt}`;
        const key = await ApiService.PatientApp.GetDicomZipLink(item.studyId, txt);
        const link = `${window?.AppSettings?.server?.api}/api/PatientApp/GetDicomZipWithKey/${tokenType}/${key.data}`;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: t('Study Link'),
                    text: `${patient?.name} ${patient?.lastname}\n${item.displayName}\n${date_txt}\n\n`,
                    url: link
                })
            }
            catch (e) {
                navigator.clipboard.writeText(link).then(() => alert(t('Link copied to clipboard')));
            }
        } else {
            navigator.clipboard.writeText(link).then(() => alert(t('Link copied to clipboard')));
        }
    }

    const openStudy = async (reportId) => {
        const res = ApiService.PatientApp.GetStudyMetadata(reportId, 4);
        const url = `${window?.AppSettings?.server?.api}/api/ohif/viewer/dicomjson?url=${res}`;
        window.open(url);
    }

    const getProfileLink = async (tokenType) => {
        const res = await ApiService.PatientApp.GetAccessToken(tokenType);
        const shareUrl = `${window?.AppSettings?.server?.api}/ProfileShare?access_token=${res.data}`;
        const data = await ApiService.PatientApp.CreateUrl(shareUrl);
        if (navigator.share) {
            try {
                await navigator.share({
                    title: t('Study Viewer Link'),
                    text: `${patient?.name} ${patient?.lastname}`,
                    url: `${window?.AppSettings?.server?.api}/api/PatientApp/GetUrl/${data.data}`
                });
            } catch (e) {
                navigator.clipboard.writeText(shareUrl).then(() => alert(t('Link copied to clipboard')));
            }
        } else {
            navigator.clipboard.writeText(shareUrl).then(() => alert(t('Link copied to clipboard')));
        }
    }

    useEffect(() => {
        getReports();
        getStudies();
    }, []);

    const renderReportsList = (dataSource) => (
        <List
            itemLayout="horizontal"
            dataSource={dataSource}
            size="large"
            renderItem={(item, index) => (
                <List.Item>
                    <List.Item.Meta
                        title={(
                            <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                                <Typography.Text style={{ fontSize: '13pt', display: 'flex', alignItems: 'start' }}>
                                    <div>
                                        <div style={{ marginTop: 8, marginLeft: 0 }}>
                                            {
                                                (item.confirmDate) && (
                                                    <Typography.Link style={{ fontSize: '12pt' }}
                                                        onClick={() => {
                                                            if (item.reportId && item.reportId !== 0) {
                                                                openRisPdf(item.reportId);
                                                            } else {
                                                                openPdf(item.fileId);
                                                            }
                                                        }}
                                                    >
                                                        <FilePdfOutlined style={{ fontSize: '15px', color: 'grey', marginRight: 4 }} />
                                                        {new Date(item.confirmDate).toLocaleDateString()}
                                                        &emsp;
                                                        {item.displayName}
                                                    </Typography.Link>
                                                )
                                            }
                                            {
                                                !(item.confirmDate) && (
                                                    <Typography.Text style={{ fontSize: '12pt' }}>
                                                        <LoadingOutlined style={{ fontSize: '18px' }} /> {t('Waiting...')}
                                                        &emsp;
                                                        {item.displayName}
                                                    </Typography.Text>
                                                )
                                            }
                                        </div>
                                        <div style={{ display: 'flex', color: '#777777', flexDirection: 'row', flexWrap: 'wrap' }}>
                                            <div style={{ fontSize: '10pt', width: 120, marginLeft: 0 }}>{t('Accession Number')}:</div>
                                            <div style={{ fontSize: '10pt' }}>{item.accessionNumber ? item.accessionNumber : '-'}</div>
                                        </div>
                                    </div>
                                </Typography.Text>
                            </div>
                        )}
                    />
                </List.Item>
            )}
        />
    );

    const renderAllStudyList = (dataSource) => (
        <List
            itemLayout="horizontal"
            dataSource={dataSource}
            size="large"
            renderItem={(item, index) => (
                <List.Item>
                    <List.Item.Meta
                        title={(
                            <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }}>
                                <Typography.Text style={{ fontSize: '13pt', display: 'flex', alignItems: 'start' }}>
                                    <div>
                                        {new Date(item.studyDate).toLocaleDateString()} - {item.studyDescription} ({item.modality})
                                        <div style={{ display: 'flex', color: '#777777', flexDirection: 'row', flexWrap: 'wrap' }}>
                                            <div style={{ fontSize: '10pt', width: 100, marginLeft: 0 }}>{t('Görüntü Sayısı')}:</div>
                                            <div style={{ fontSize: '10pt' }}>{item.numberOfStudyRelatedInstance}</div>
                                            
                                            {
                                                item.reports?.map(r => (
                                                    <div style={{ fontSize: '10pt', width: 100, marginLeft: 16 }}>{r.accessionNumber}</div>
                                                ))
                                            }
                                        </div>
                                        <br />
                                        <div style={{ display: 'flex', color: '#777777', flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: isMobile ? 'column' : 'row', gap: 8 }}>
                                                <Button
                                                    type="primary"
                                                    style={{ flex: 1, minWidth: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                    onClick={() => openStudy(item.studyId)}
                                                    icon={<FolderOpenOutlined />}
                                                >
                                                    Görüntüleyicide Aç
                                                </Button>
                                                <Button
                                                    color={'success'}
                                                    style={{ flex: 1, minWidth: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                    onClick={() => downloadZip(item)}
                                                    icon={<CloudDownloadOutlined />}
                                                >
                                                    DICOM İndir
                                                </Button>
                                                <Button
                                                    type="dashed"
                                                    style={{ flex: 1, minWidth: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                    onClick={async () => {
                                                        const tokenType = await TokenDurationModal(1);
                                                        if (tokenType !== null) {
                                                            await getLink(item, tokenType);
                                                        }
                                                    }}
                                                    icon={<ShareAltOutlined />}
                                                >
                                                    DICOM Paylaş
                                                </Button>
                                                <Button
                                                    type="dashed"
                                                    style={{ flex: 1, minWidth: 150, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                    onClick={async () => {
                                                        const tokenType = await TokenDurationModal(1);
                                                        if (tokenType !== null) {
                                                            await getOhifLink(item, tokenType);
                                                        }
                                                    }}
                                                    icon={<ShareAltOutlined />}
                                                >
                                                    Görüntüleyici Linki Paylaş
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Typography.Text>
                            </div>
                        )}
                    />
                </List.Item>
            )}
        />
    );

    return (
        <div>
            <Card>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'start', gap: 24, flexWrap: 'wrap' }}>
                    <div style={{ minWidth: 400 }}>
                        <table>
                            {<tr>
                                <td colSpan={2}>
                                    <Typography.Title level={3}>{patient?.name} {patient?.lastname}</Typography.Title>
                                </td>
                            </tr>}
                            <tr>
                                <td>{t('Identity')}:</td>
                                <td>{patient?.customId}</td>
                            </tr>
                            <tr>
                                <td>{t('Birthdate')}:</td>
                                <td>{patient?.birthDay?.toString()?.padStart(2, '0')}/{patient?.birthMonth?.toString()?.padStart(2, '0')}/{patient?.birthYear}</td>
                            </tr>
                            <tr>
                                <td>{t('Gender')}:</td>
                                <td>{t(patient?.gender)}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <Typography.Text>
                    <br />
                    Sistemde kayıtlı rapor ve çekimlerinizi aşağıda listeleyebilirsiniz. Eksik veya hatalı bir bilgi varsa lütfen <b><i>"{t('Contact')}"</i></b> kısmından bize ulaşın.
                    <br />
                </Typography.Text>
                <br />
                <Button
                    style={{ flex: 1, width: 'auto', display: 'flex', alignItems: 'center' }}
                    onClick={async () => {
                        const tokenType = await TokenDurationModal(1);
                        if (tokenType !== null) {
                            await getProfileLink(tokenType);
                        }
                    }}
                >
                    <ShareAltOutlined />
                    Profili Paylaş
                </Button>



            </Card>
            <div style={{ backgroundColor: 'white', marginTop: 25, padding: 10 }}>
                <Tabs defaultActiveKey="2" items={[
                    {
                        key: '2',
                        label: 'Çekimler',
                        children: renderAllStudyList(studies)
                    },
                    {
                        key: '1',
                        label: 'Raporlar',
                        children: renderReportsList(reports)
                    }
                ]} />
            </div >
        </div >
    )
}